import { Component, Input, Inject, Output, EventEmitter } from '@angular/core';
import { QuoteNote } from '../../models/quote.note.interface';
import { QuoteService } from '../../../quote/services/quote.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { QuoteBase } from '../../models/quote.base.interface';
import {RolePermission } from '../../models/role.permission.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { NgForm } from '@angular/forms';

export interface NoteDialogData extends QuoteNote {
}

@Component({
  selector: 'app-project-notes',
  templateUrl: './project.notes.component.html',
  styleUrls: ['./project.notes.component.scss']
})
export class ProjectNotesComponent extends AbstractBiditComponent {
  errors: string;

  canEdit: boolean = true;

  notes: QuoteNote[] = new Array();

  private _quote: QuoteBase;

  constructor(private dialog: MatDialog, private quoteService: QuoteService, deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  @Input()
  public set project(value: QuoteBase) {
    if (value) {
      this._quote = value;

      if (this._quote.quote_Converted != null)
        this.canEdit = QuoteService.hasPermission(RolePermission.EditJob);
      else if (this._quote.quote_IsLead)
        this.canEdit = QuoteService.hasPermission(RolePermission.EditLead);
      else
        this.canEdit = QuoteService.hasPermission(RolePermission.EditQuote);

      this.loadNotes();
    }
  }

  @Output() updated = new EventEmitter<QuoteBase>();

  loadNotes() {
    this.notes = this._quote.notes;
  }

  deleteNote(note: QuoteNote) {
    var proceed = confirm($localize`Delete selected item?`);
    if (!proceed) return;

    this.quoteService.deleteQuoteNote(note.quoteNote_ID)
      .subscribe(
        {
          next: (data) => {
            this.updated.emit(this._quote)
          },
            error: (error: string) => this.onError(error)
          });

  }

  editNote(note: QuoteNote) {
    const dialogRef = this.dialog.open(AddNoteDialog, {
      width: '500px',
      data: note
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
        if (result) {
          this.updated.emit(this._quote);
        }
      }
    });

  }

  addNote() {
    const dialogRef = this.dialog.open(AddNoteDialog, {
      width: '500px',
      data: {
        quote_ID: this._quote.quote_ID
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
        if (result) {
          this.updated.emit(this._quote);
        }
      }
    });

  }
}

@Component({
  selector: 'add.note.dialog',
  templateUrl: 'add.note.dialog.html'
})
export class AddNoteDialog extends AbstractBiditComponent {

  constructor(
    deviceDetectorService: DeviceDetectorService,
    private quoteService: QuoteService,
    public dialogRef: MatDialogRef<AddNoteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: NoteDialogData) {
    super(deviceDetectorService);
  }

  addNote(form: NgForm): void {
    if (this.data.quoteNote_Text == '') {
      alert($localize`No note provided`);
      return;
    }

    if (form.valid) {
      let note = {
        quote_ID: this.data.quote_ID,
        quoteNote_ID: this.data.quoteNote_ID,
        quoteNote_Text: this.data.quoteNote_Text,
        quoteNote_Created: this.data.quoteNote_Created,
        quoteNote_CreatedBy: this.data.quoteNote_CreatedBy,
        quoteNote_Modified: this.data.quoteNote_Modified,
        quoteNote_ModifiedBy: this.data.quoteNote_ModifiedBy,
        quoteNote_Attachment: null,
        attachment: null
      } as QuoteNote;

      this.isRequesting = true;
      this.quoteService.saveQuoteNote(note)
        .subscribe(
          {
            next: (data) => {
              this.dialogRef.close(data)
            },
              error: (error: string) => this.onError(error)
            });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
